import { useTranslation } from "react-i18next";
import { useSubscribeToStockNotificationMutation } from "../api/stockNotificationApi";
import { useMutationWithFeedback } from "../../../../common/hooks/useMutationWithFeedback";

export const useStockNotification = () => {
  const { t } = useTranslation();
  const [subscribeMutation, mutationResult] =
    useSubscribeToStockNotificationMutation();

  const { trigger, isLoading } = useMutationWithFeedback({
    mutation: [subscribeMutation, mutationResult],
    loadingMessage: t(
      "stockNotification.loading",
      "Subscribing to notifications..."
    ),
    successMessage: t(
      "stockNotification.success",
      "You will be notified when the product is in stock."
    ),
    errorMessages: {
      default: t("stockNotification.error", "Subscription failed."),
      invalid_email: t(
        "validation.emailInvalid",
        "Please enter a valid email address."
      ),
      invalid_product: t(
        "stockNotification.invalidProduct",
        "Invalid product."
      ),
      // Map security errors to generic messages
      spam_detected: t(
        "feedback.default.error",
        "An error occurred. Please try again."
      ),
    },
    successToastType: "success",
  });

  return {
    handleSubscribe: trigger,
    isLoading,
    isSuccess: mutationResult.isSuccess,
  };
};
